import React from 'react'
import Translation from 'services/translation.service';
import Visa from '../../../../assets/img/Visa Logo.png';
import Master from '../../../../assets/img/MasterCard Logo.png';
import Apple from '../../../../assets/img/Apple Pay Logo.png';
import Vector from '../../../../assets/img/Vector.png';
import './proceed-payment-card.scss'
import { connect } from 'react-redux';

function ProceedPaymentCard(props) {
    const { activeTab, activeBalance, data, dayOfWeek, dayOfMonth, displayDetail, vatValue } = props
    const isButtonActive = activeBalance?.activeStatus && (dayOfMonth || dayOfWeek) && activeTab
    return (
        <>
            <div className={activeBalance.activeStatus ? 'card card-hight-balance' : 'card'}>


                {activeBalance?.activeStatus && <>
                    <div>
                    <span className='info' >{`${Translation.key('proceed-payment-blanced-received')}: `} </span>
                    <span className='infoNumbers'>{Math.round(Number(activeBalance?.balance)/(1+Number(vatValue)) * 100) / 100 } {activeBalance?.currency}</span>                        
                    </div>
                    <br />
                    <span className='vat'>{Translation.key('proceed-payment-vat-inclusive')+" "+ (Number(vatValue))*100 +'%'+ " "+ Translation.key('proceed-payment-vat')}</span>
                </>}


                <button disabled={!isButtonActive} onClick={() => displayDetail(activeBalance.id, data)} className={isButtonActive ? 'buttonCard active' : 'buttonCard'} ><span>{Translation.key('generic_btn_value_activate')}</span></button>
                <div className='imag-container'>
                    <img src={Visa} />
                    <img src={Master} />
                    <img src={Apple} />
                    <img src={Vector} />
                </div>
            </div>

        </>
    )
}

const mapStateToProps = state => {
    return {
        links: state.layout.routes,
        lang: state.layout.iso,
        routesLoading: state.layout.loading,
        userInfo: state.user.userInfo

    };
};


export default connect(
    mapStateToProps
)(ProceedPaymentCard);